import { render, staticRenderFns } from "./LightningJavazon.vue?vue&type=template&id=43caf99c"
import script from "./LightningJavazon.vue?vue&type=script&lang=js"
export * from "./LightningJavazon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports